// eslint-disable-next-line no-multi-assign
globalThis.Robodog = module.exports = require('./bundle-legacy.js')
